import { render, staticRenderFns } from "./Extract.vue?vue&type=template&id=76f024d2&scoped=true"
import script from "./Extract.vue?vue&type=script&lang=js"
export * from "./Extract.vue?vue&type=script&lang=js"
import style0 from "./Extract.vue?vue&type=style&index=0&id=76f024d2&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76f024d2",
  null
  
)

export default component.exports